module.exports = __webpack_public_path__ + "static/media/Z2.ab43686d.jpg";